const SKELETON_VARIANT = {
  TABLE: 'table',
  STATIC_CONTENT: 'staticContent',
  PREVIEW: 'preview',
};

export { SKELETON_VARIANT };
